import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-label',
    template: require('./icon-label.component.html'),
    styles: [require('./icon-label.component.scss')]
})
export class IconLabelComponent {
    @Input() public icon: any;
    @Input() public label: any;
    @Input() public customClass: any;
    @Input() public textClass: any;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/icon-label/icon-label.component.ts